import { IRoute, Routes } from './route';

export const RouteMenus: IRoute[] = [Routes.HOME, Routes.NHAN_VIEN, Routes.BANG_LUONG, Routes.PHAN_HOI_LUONG];
